import { RankingEntryView } from '@fsf/types';

export type Ranking = {
  nickname: string;
  device_id: string;
  total_points: number;
  total_parcours: number;
  total_length: number;
  total_height: number;
  total_ropeway_meters: number;
};

export type UserRanking = RankingEntryView;

export const timeFilterOptions = [
  { text: 'Heute', value: 'today' },
  { text: 'Diese Woche', value: 'thisWeek' },
  { text: 'Dieser Monat', value: 'thisMonth' },
  { text: 'Dieses Jahr', value: 'thisYear' },
  { text: 'Gesamt', value: 'all' },
];

export const sortFilterOptions = [
  { text: 'Punkte', value: 'points' },
  { text: 'Parcours', value: 'parcours' },
  { text: 'Parcourslänge', value: 'length' },
  { text: 'Höhenmeter', value: 'height' },
  { text: 'Seilbahnmeter', value: 'ropeway_meters' },
];
